<template>
  <div class="animated fadeIn">
    <div id="accueil-eb">
      <b-card>
      <b-row>
        <b-col md="12">
          <h1 class="display-3">Espace Relation Client</h1>
          <p>Bienvenue dans l'espace relation client.</p>
        </b-col>
      </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from '../../utils/auth';
  import {espaceRCRules as rules, hasRule} from "@/utils/rulesHelper";

  export default {
  data() {
    return {

    }
  },
  mounted() {

  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {

  }
}
</script>

<style>

</style>
